import React from 'react';

import { AgencyConfig } from '../../../types';
import { RequestStatus } from '../../../../../shared/enums/request-status';
import { getIsRequestPending } from '../../../../../shared/utils';
import { SHLogoIcon, SHLogoTypographySm } from '../../../../../shared/svg';
import LogoSecondary from '../../../../../shared/components/logo-secondary';

type IProps = {
  agencyConfig: AgencyConfig;
  agencyConfigRequestStatus: RequestStatus;
};

const Logo: React.FC<IProps> = ({
  agencyConfig,
  agencyConfigRequestStatus,
}) => {
  if (
    getIsRequestPending(agencyConfigRequestStatus) ||
    (agencyConfig && agencyConfig?.isLocallyCached)
  ) {
    return null;
  }

  if (
    !agencyConfig?.icon &&
    window.location.origin === process.env.REACT_APP_BASE_URL
  ) {
    return (
      <>
        <div className="logo-icon">
          <SHLogoIcon />
        </div>
        <div className="logo-text">
          <SHLogoTypographySm />
        </div>
      </>
    );
  }

  return (
    <>
      <LogoSecondary className="logo-icon" />
      <div className="logo-text agency-logo-text">
        {agencyConfig?.companyName}
      </div>
    </>
  );
};

export default Logo;
